import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-under-development-illustration',
  templateUrl: './under-development-illustration.component.html',
  styleUrls: ['./under-development-illustration.component.css']
})
export class UnderDevelopmentIllustrationComponent { }
